<template>
  <!-- 应收款明细表 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
   <!-- 列表 -->
    <div>
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <el-button @click="calculateMoney">计算费用</el-button>
           <el-button @click="calculateMoneyList">批量计算费用</el-button>
           <el-button @click="updateDate">修改计费时间</el-button>
           <el-button @click="add">新增</el-button>
           <el-button @click="del_list">全部删除</el-button>
           <router-link to="/pindex/MoneyCheck">
             <el-button style="color: #606266;" >应收款审核</el-button>
           </router-link>
         </div>
         <div class="cdj_div">查询条件-<span v-if="search">{{search}}</span><span v-else>所有房产</span></div>
         <div class="cdj_table">
           <div class="cdj_display">
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">客户名称</div>
                 <div class="cdj_el-input">
                     <el-input size="mini" v-model="data.name"></el-input>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费项目</div>
                 <div class="cdj_el-input">
                    <el-select v-model="data.chargeItem_name_id" style="width: 100%" clearable @change="chargeItem_names" size="mini" placeholder="收费项目">
                      <el-option v-for="item in chargeitem_1" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                    </el-select>
                 </div>
               </div>
             </div>
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">计费周期</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-date-picker size="mini" v-model="s_startDate" type="date" placeholder="开始时间"></el-date-picker>
                   <span class="cdj_text_data">至</span>
                   <el-date-picker size="mini" v-model="e_endDate" type="date" placeholder="结束时间"></el-date-picker>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费标准</div>
                    <el-select v-model="data.chargeitemID" class="cdj_el-input" size="mini" clearable placeholder="收费标准">
                      <el-option v-for="item in charges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
               </div>
             </div>
           </div>
        </div>
         <!-- 数据列表 -->
         <el-tabs v-model="activeName" @tab-click="handleClick"  style="margin-top: 7px;">
          <el-tab-pane label="应收明细" name="first">
            <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="47vh">
              <el-table-column prop="h_name" label="客户名称" width="100"></el-table-column>
              <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
              <el-table-column prop="charge_name" label="收费标准" width="170"></el-table-column>
              <el-table-column  label="计费周期" width="140">
                <template slot-scope="scope">
                  {{scope.row.startDate}}-{{scope.row.endDate}}
                </template>
              </el-table-column>
              <el-table-column prop="should_charge_date" label="应收日期" width="80"></el-table-column>
              <el-table-column prop="xsc_Amount" label="面积/用量" width="80"></el-table-column>
              <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
              <el-table-column prop="charge" label="应收金额" width="80"></el-table-column>
              <el-table-column prop="a_name" label="生成人" width="80"></el-table-column>
              <el-table-column prop="a_update_name" label="修改" width="80"></el-table-column>
              <el-table-column prop="a_check_name" label="审核" width="80"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <div style="color: blue;cursor: pointer;" @click="updateId(scope.row.id)">修改</div>
                    <div style="color: red;margin-left: 3px;cursor: pointer;" @click="del(scope.row.id)">删除</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="pages" v-if="desserts">
              <Page :total="total" :page-size="page" @on-change="change"  show-total />
            </div>
          </el-tab-pane>
          <el-tab-pane label="应收汇总" name="second">
            <el-table ref="multipleTable" :data="routineSum" border tooltip-effect="dark" style="width: 100%" height="47vh">
              <el-table-column prop="name" label="收费项目" width="150"></el-table-column>
              <el-table-column  label="计费周期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.startDate}}-{{scope.row.endDate}}
                </template>
              </el-table-column>
              <el-table-column prop="endDate" label="应收日期" width="120"></el-table-column>
              <el-table-column prop="xsc_Amount" label="面积/用量" width="120"></el-table-column>
              <el-table-column prop="charge" label="应收金额" width="120"></el-table-column>
              <el-table-column prop="discount" label="减免金额" width="120"></el-table-column>
              <el-table-column prop="money" label="实际应收金额" width="120"></el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="查看日记" name="third">

            <el-table ref="multipleTable" :data="dessertsLog" border tooltip-effect="dark" style="width: 100%" height="47vh">
              <el-table-column prop="homeName" label="房产" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="进度" width="320">
                <template slot-scope="scope">
                  <el-progress style="width: 300px;" :text-inside="true" :stroke-width="26" :percentage="scope.row.count"></el-progress>
                </template>
              </el-table-column>
              <el-table-column prop="statue" label="处理结果" width="80"></el-table-column>
              <el-table-column  label="计费周期" width="160">
                <template slot-scope="scope">
                  {{scope.row.startDate}}-{{scope.row.endDate}}
                </template>
              </el-table-column>
              <el-table-column prop="end" label="总对象" width="80"></el-table-column>
              <el-table-column prop="number_end" label="总条数" width="80"></el-table-column>
              <el-table-column label="生成条数" width="120">
                <template slot-scope="scope">
                  {{scope.row.start-scope.row.number}}
                </template>
              </el-table-column>
              <el-table-column prop="number" label="已存在条数" width="100"></el-table-column>
              <el-table-column prop="name" label="生成人" width="80"></el-table-column>
              <el-table-column prop="date" label="发生时间" width="140"></el-table-column>
            </el-table>
            <div class="pages">
              <Page :total="totallog" :page-size="pagelog" @on-change="changelog"  show-total />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 计算费用 -->
    <Modal
      v-model="calculate"
      width="700"
      title="计算费用"
      okText="开始计算"
      :loading="loadingModal"
      @on-ok="calculateMoneyAdd">
      <div>
          <div class="cdj_div">计算费用-总计有<span style="color: red;">[{{count}}]</span>个计算对象，房产：{{data.homeName}}</div>
           <div class="cdj_table" >
               <div class="cdj_left" style="width: 100%;">
                 <div class="cdj_left_display">
                   <div class="cdj_left_display_background">是否按天计算</div>
                   <div class="cdj_el-input" style="margin-top: 3.5px;">
                     <el-radio v-model="calculateData.day_type" label="1">是</el-radio>
                     <el-radio v-model="calculateData.day_type" label="2">否</el-radio>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">开始时间设置</div>
                   <div class="cdj_el-input" style="margin-top: 3.5px;">
                     <el-checkbox v-model="calculateData.start_type" label="1">房间收费设置的开始时间</el-checkbox>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">计费周期</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="startDate" type="date" placeholder="开始时间"></el-date-picker>
                     <span class="cdj_text_data">至</span>
                     <el-date-picker size="mini" v-model="endDate" type="date" placeholder="结束时间"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">收费项目</div>
                   <div class="cdj_el-input">
                      <CheckboxGroup v-model="chargeItem_name_id">
                        <div style="display: flex;flex-wrap: wrap;margin-top: 3px;">
                          <div v-for="it in charge">
                            <Checkbox  :label="it.id">{{it.chargeItem_name}}</Checkbox>
                          </div>
                        </div>
                      </CheckboxGroup>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">进度</div>
                   <div class="cdj_el-input">
                     <el-progress style="margin-top: 5px;" :text-inside="true" :stroke-width="20" :percentage="timecount"></el-progress>
                   </div>
                 </div>
                 <div style="margin-top: 7px;">
                   开始计算的数据准备要求<br>
                   1、确认水费、电费、管理费等费用的设置已经完成;<br>
                   2、确认房产管理中房产登记-房屋基本信息中的面积已经设置完成;<br>
                   3、确认房间收费设置和收费对象设置完成及准确;<br>
                   4、在审核和结账之前，如果发现有数据错误录入修改后可以重新计算!<br>
                   5、计算过程可能会进行较长的时间，请耐心等待。<br>
                   6、点击开机计算后，可等待，也可关闭，可以在查看日记中查看进度。<br>
                 </div>
               </div>
          </div>
      </div>
    </Modal>

    <!-- 修改计费时间 -->
    <Modal
      v-model="updateDateModel"
      width="700"
      title="修改计费时间"
      okText="开始修改"
      :loading="loadingModal"
      @on-ok="updateDateAdd">
      <div>
          <div class="cdj_div">修改计费的开始时间、结束时间、应收日期，房产：{{data.homeName}}</div>
           <div class="cdj_table" >
               <div class="cdj_left" style="width: 100%;">
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">计费开始时间</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.startDate" type="date" placeholder="开始时间"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">计费结束时间</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.endDate" type="date" placeholder="结束时间"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">应收日期</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">进度</div>
                   <div class="cdj_el-input">
                     <el-progress style="margin-top: 5px;" :text-inside="true" :stroke-width="20" :percentage="0"></el-progress>
                   </div>
                 </div>
                 <div style="margin-top: 7px;">
                   1、计费的开始日期、结束日期、应收日期是系统自动根据在收费标准设置中设置的参数进行推算出来的，但是实际费用的收取时间会有变化。<br>
                   2、利用本功能就可以重新批量修改这三个日期。<br>
                   3、如果重新执行了费用核算功能，则这些日期需要重新修改。<br>
                   4、最好先确认了计算出来的费用金额结果已经准确后在来修改。<br>
                   5、这些日期的修改不会影响核算的金额。<br>
                   6、新录入的开始日期和结束日期必须在已经结账过的费用日期之外。<br>
                   <span style="color:red;">7、请至少输入一个日期，如果没有输入日期，则表示不做修改。</span>
                 </div>
               </div>
          </div>
      </div>
    </Modal>
    <!-- 新增 -->
    <Modal
      v-model="addmodel"
      width="950"
      title="应收款详细信息"
      okText="计算费用"
      :loading="loadingModal"
      @on-ok="orderAdd">
      <div>
          <div class="cdj_div">应收款明细信息，房产：{{data.homeName}}</div>
           <div class="cdj_table">
              <div class="cdj_display">
                <!-- 左 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>房产</div>
                    <div class="cdj_el-input">
                        <el-select
                            style="width:100%"
                            v-model="houesmoney.house_id"
                            class="search"
                            size="mini"
                            filterable
                            @change="houseCharging"
                            remote
                            clearable
                            reserve-keyword
                            placeholder="可搜索房产/客户姓名"
                            :remote-method="remoteMethod"
                            :loading="loading">
                            <el-option
                              v-for="item in selectList"
                              :key="item.id"
                              :label="item.house"
                              :value="item.id">
                            </el-option>
                          </el-select>
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">联系人</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.name" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>收费项目</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.xsc_ChargeItemID_id" style="width: 100%" clearable @change="chargeItem_names1" size="mini" placeholder="收费项目">
                        <el-option v-for="item in chargeitem_2" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收日期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:100%" v-model="houesmoney.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>单价</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_Price"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.charge"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">已缴金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.PaidChargeSum"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">减免类型</div>
                    <div class="cdj_el-input">
                        <el-select v-model="houesmoney.discountType" style="width: 100%" clearable size="mini" placeholder="减免类型">
                          <el-option v-for="item in discount_type" :key="item.number" :label="item.name" :value="item.number"></el-option>
                        </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">面积</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_Amount"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">备注</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.remark"></el-input>
                    </div>
                  </div>
                </div>
                <!-- 右 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>客户名称</div>
                    <div class="cdj_el-input" style="display:flex;">
                        <el-input size="mini" v-model="houesmoney.h_name" :disabled="true"></el-input>
                        <el-button size="mini" style="margin-left:2px;" @click="user">选择</el-button>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">联系电话</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.phoen" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>收费标准</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.charge_id" style="width: 100%" clearable @change="chargeitem_list" size="mini" placeholder="收费标准">
                        <el-option v-for="item in charges1" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>计费周期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.startDate" type="date" placeholder="开始时间"></el-date-picker>
                      <span style="margin-top: 3.5px;">至</span>
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.endDate" type="date" placeholder="结束时间"></el-date-picker>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>承担比例</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.proportion"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>计费标志</div>
                    <div class="cdj_el-input" style="margin-top: 3.5px;">
                      <el-radio v-model="houesmoney.sign" label="1">是</el-radio>
                      <el-radio style="margin-left: -20px;" v-model="houesmoney.sign" label="2">否</el-radio>
                      （是否按照计费时间自动计算)
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">挂账金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.account"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">减免金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.discount"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.chargePay"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收标志</div>
                    <div class="cdj_el-input" style="margin-top: 3.5px;">
                      <el-radio v-model="houesmoney.chargePaySign" label="1">普通应收</el-radio>
                      <el-radio style="margin-left: -20px;" v-model="houesmoney.chargePaySign" label="2">调整应收</el-radio>
                    </div>
                  </div>
                </div>
              </div>
           </div>
      </div>
    </Modal>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>

    <!-- 批量计算费用 -->
    <RoutineExpenseLists ref="reflist"></RoutineExpenseLists>
</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
// const chargeItem_name_id = [];
export default {
  name: "FormsOweMoney",
  data () {
    return {
      house:'',
      modal1:false,
      houesmoney:{
        id:'',
        house_id:'',
        h_name:'',
        name:'',
        phoen:'',
        xsc_ChargeItemID_id:'',
        charge_id:'',
        should_charge_date:'',
        xsc_Price:'',
        proportion:'1',
        sign:'2',
        account:'0.00',
        chargePaySign:'1',
        charge:'',
        PaidChargeSum:'0.00',
        discount:'0.00',
        discountType:'',
        xsc_Amount:'',
        remark:'',
        startDate:'',
        endDate:'',
        chargePay:'',
      },
      selectList:[],
      dessertsLog:[],
      totallog:0,
      pagelog:12,
      calculate:false,
      addmodel:false,
      updateDateModel:false,
      loadingModal:true,
      activeName: 'first',
      startDate:'',
      endDate:'',
      s_startDate:'',
      e_endDate:'',
      chargeitem:[],
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      data:{
        pid:'',
        house_id:'',
        homeName:'',
        s_startDate:'',
        e_endDate:'',
        chargeitemID:[],
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:2,
        days:'2',
        start:'',
        name:'',
      },
      calculateData:{
        pid:'',
        homeName:'',
        day_type:'2',
        start_type:'',
        startDate:'',
        endDate:'',
      },
      updates:{
        startDate:'',
        endDate:'',
        should_charge_date:'',
      },
      chargeItem_name_id:[],
      chargeitem_type:[],
      chargeitem_1:[],
      chargeitem_2:[],
      charge:[],
      charges:[],
      charges1:[],
      homeName:'',
      house:'',
      count:'',
      routineSum:[],
      isIndeterminate: true,
      developer:'',
      discount_type:[],
      timer:'',
      timecount:0,
      ids:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    //常规收费项目
    this.$myhttp.get('admin/common/chargeitem_name',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem_1 = backdata.data.data;
        this.chargeitem_2 = backdata.data.data;
    });
    //减免类型
    this.$myhttp.get('admin/common/discount_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.discount_type = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //获得面积
    houseCharging(e){
      this.selectList.map(req=>{
        if(req.id==e){
          this.houesmoney.xsc_Amount=req.charging;
        }
      })
    },
    //获得收费标准单价
    chargeitem_list(e){
      // console.log(e);
      // console.log(this.charges1);
      this.charges1.map(req=>{
        if(req.id == e){
          this.houesmoney.xsc_Price=req.charge;
        }
      })
    },
    //选择客户
    user(){
      this.modal1 = true;
    },
    //点击客户
    roomUser(){
      this.developer = this.$refs.child.getUser();
      this.houesmoney.h_name = this.developer.name;
    },
    //搜索房产
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get("admin/common/house_text?text=" +query +"&project_id=" +this.data.pid,{
          "Content-Type": "application/json",
          }).then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //计算费用
    calculateMoney(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
      }else{
        this.timecount = 0;
        this.calculate = true;
      }
    },
    //计算费用生成
    calculateMoneyAdd(){
      this.dates();
      this.calculateData.pid = this.data.pid;
      this.calculateData.homeName=this.data.homeName;
      let data = {'data':this.calculateData,'chargeItem':this.chargeItem_name_id};
      this.$myhttp.post('admin/RoutineExpense/calculateMoneyAdd',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            this.ids = backdata.data.data;
            this.times(1);
            this.$Message.success(backdata.data.message);
          }else{
            this.loadingModals();
            this.$Message.error(backdata.data.message);
          }
      });
    },
    calculateMoneyList(){
      this.$refs.reflist.getInvo();
    },
    //定时器
    times(id){
      let _this = this;
      let oen = 1;
      if(id == 1){
        let ids = {'id':this.ids}
        this.timer = setInterval(() => {
          _this.$myhttp.post('admin/RoutineExpense/orderRoutineLogID',ids,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              let data = backdata.data.data;
              _this.timecount = data;
              if(data >= 100){
                this.$confirm(backdata.data.text, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                }).catch(() => {

                });
                setTimeout(() => {
                   _this.change(1);
                   _this.emdtime();
                }, 1000)
              }
          });
          if(oen > 400){
            _this.emdtime();
          }
          oen++
        }, 2000);
      }else{
        _this.emdtime();
        this.timer = setInterval(() => {
           _this.changelog(_this.data.page);
           if(oen > 400){
             _this.emdtime();
           }
           oen++
        }, 2000);
      }
    },
    emdtime(){
      let _this = this;
      this.loadingModals();
      this.calculate = false;
      clearInterval(this.timer);
    },
    //修改计费周期
    updateDate(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
      }else{
        this.updateDateModel = true;
      }
    },
    updateDateAdd(){
      let data = {'data':this.data,'update':this.updates}
      this.$myhttp.post('admin/RoutineExpense/update_list',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loadingModals();
          if(backdata.data.code == 200){
            this.updateDateModel = false;
            this.change(1);
            this.$Message.success(backdata.data.message);
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //删除
    del(id){
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        let ids = {'id':id};
        this.$myhttp.post('admin/RoutineExpense/del',ids,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //全部删除
    del_list(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
        return false;
      }
      this.dates();
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/RoutineExpense/del_list',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //新增
    add(){
      if(!this.data.pid){
        this.$Message.error("点击左边树选择项目");
        return false;
      }
      if(this.houesmoney.id){
        this.houesmoney={
          id:'',
          house_id:'',
          h_name:'',
          name:'',
          phoen:'',
          xsc_ChargeItemID_id:'',
          charge_id:'',
          should_charge_date:'',
          xsc_Price:'',
          proportion:'1',
          sign:'2',
          account:'0.00',
          chargePaySign:'1',
          charge:'',
          PaidChargeSum:'0.00',
          discount:'0.00',
          discountType:'',
          xsc_Amount:'',
          remark:'',
          startDate:'',
          endDate:'',
          chargePay:'',
        };
      }
      this.addmodel = true;
    },
    orderAdd(){
      let data = {'houesmoney':this.houesmoney,'developer':this.developer}
      //ERP.showLoading()
      this.$myhttp.post('admin/RoutineExpense/add',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          //ERP.hideLoading()
          this.loadingModals();
          if(backdata.data.code == 200){
            this.addmodel = false;
            this.$Message.success(backdata.data.message);
            this.change(1);
            //this.change(1);
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //修改查询
    updateId(id){
      this.$myhttp.get("admin/RoutineExpense/getUpdate?id="+id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          //console.log(backdata.data.data);
          this.houesmoney = backdata.data.data.order[0];
          this.selectList = backdata.data.data.house;
          this.charges1 = backdata.data.data.charge;
          this.developer = backdata.data.data.customer;
          this.addmodel = true;
      });
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.data.chargeitemID = '';
          this.charges = backdata.data.data;
      });
    },
    chargeItem_names1(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.houesmoney.xsc_ChargeItemID_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.houesmoney.chargeitemID = '';
          this.charges1 = backdata.data.data;
      });
    },
    //获得当前多少页,分页
    change(e){
      this.dates();
      ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/RoutineExpense/orderRoutine',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          ERP.hideLoading()
      });
    },
    //日记分页
    changelog(e){
      this.dates();
      this.data.page = e;
      this.$myhttp.post('admin/RoutineExpense/orderRoutineLog',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.dessertsLog = data.data;
          this.totallog = data.count;
          this.pagelog = data.pageSize;
      });
    },
    //点击切换
    handleClick(tab, event){
      this.emdtime();
      if(tab.name == "second"){
        this.moneySum();
      }
      if(tab.name == "third"){
        this.times(2);
      }
    },
    //应收汇总
    moneySum(){
      this.dates();
      //ERP.showLoading()
      this.$myhttp.post('admin/RoutineExpense/orderRoutineSum',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          if(backdata.data.code == 200){
            this.routineSum = data;
          }else{
            this.routineSum = [];
            //this.$Message.success(backdata.data.message);
          }
          //ERP.hideLoading()
      });
    },
    //时间转换
    dates(){
      //计算费用
      this.calculateData.startDate = '';
      this.calculateData.endDate = '';
      if(this.startDate != null && this.startDate != ''){
        let d = this.startDate;//开始时间
        let startDate = new Date(d).getTime()/1000;
        startDate = Number(startDate).toFixed(0);
        this.calculateData.startDate = startDate;
      }
      if(this.endDate != null && this.endDate != ''){
        let d = this.endDate;//开始时间
        let endDate = new Date(d).getTime()/1000;
        endDate = Number(endDate).toFixed(0);
        this.calculateData.endDate = endDate;
      }
      //搜索
      this.data.s_startDate = '';
      this.data.e_endDate = '';
      if(this.s_startDate != null && this.s_startDate != ''){
        let d = this.s_startDate;//开始时间
        let s_startDate = new Date(d).getTime()/1000;
        s_startDate = Number(s_startDate).toFixed(0);
        this.data.s_startDate = s_startDate;
      }
      if(this.e_endDate != null && this.e_endDate != ''){
        let d = this.e_endDate;//开始时间
        let e_endDate = new Date(d).getTime()/1000;
        e_endDate = Number(e_endDate).toFixed(0);
        this.data.e_endDate = e_endDate;
      }

    },

    //搜索
    searchs(){
      this.change(1);
      this.moneySum();
      this.changelog(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.change(1);
      this.chargesc(this.data.pid,this.data.homeName);
      this.moneySum();
      this.changelog(1);
    },
    //加载收费项目
    chargesc(pid,homeName){
      this.charge = [];
      this.chargeItem_name_id = [];
      let datas = {'pid':pid,'homeName':homeName};
      this.$myhttp.post('admin/RoutineExpense/index',datas,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.charge = backdata.data.data.charge;
          this.count = backdata.data.data.count;
          this.chargeItem_name_id = backdata.data.data.chargeItem_name_id;
      });
      // this.$myhttp.get("admin/RoutineExpense/index?pid="+pid+'&homeName='+homeName,{
      //   'Content-Type': 'application/json'
      //   }).then(backdata=>{
      //     this.charge = backdata.data.data.charge;
      //     this.count = backdata.data.data.count;
      //     this.chargeItem_name_id = backdata.data.data.chargeItem_name_id;
      // });
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10)
    },
  },
  watch:{
    //面积
    'houesmoney.xsc_Amount'(val){
        if(this.houesmoney.xsc_Price){
          this.houesmoney.charge = this.houesmoney.xsc_Price*this.houesmoney.xsc_Amount;
          this.houesmoney.charge = Math.round((parseFloat(this.houesmoney.charge))*100)/100;
          this.houesmoney.chargePay = this.houesmoney.charge
        }
    },
    //单价
    'houesmoney.xsc_Price'(val){
        if(this.houesmoney.xsc_Amount){
          this.houesmoney.charge = this.houesmoney.xsc_Price*this.houesmoney.xsc_Amount;
          this.houesmoney.charge = Math.round((parseFloat(this.houesmoney.charge))*100)/100;
          this.houesmoney.chargePay = this.houesmoney.charge
        }
    },
  },

  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue'),
    "RoutineExpenseLists": () => import('./RoutineExpenseLists.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.el-checkbox-group{
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/expense/RoutineExpense.vue